









import {
  computed,
  defineNuxtComponent,
  vue3Model
} from '~/utils/nuxt3-migration'
import Searchbar from '~/components/shared/classified/search/searchbar/Searchbar.vue'
import { useI18n } from '~/compositions/i18n'

export default defineNuxtComponent({
  model: vue3Model,
  components: {
    Searchbar
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { t } = useI18n()
    const placeholder = computed(() =>
      props.modelValue.isParts
        ? t('what part are you looking for?')
        : t('what are you looking for?')
    )
    return { placeholder }
  }
})
